var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94079 8.55263C4.94079 8.28026 4.71974 8.05921 4.44737 8.05921H0.993421C0.721053 8.05921 0.5 8.28026 0.5 8.55263V12.0066C0.5 12.2789 0.721053 12.5 0.993421 12.5H4.44737C4.71974 12.5 4.94079 12.2789 4.94079 12.0066V8.55263ZM13 8.55263C13 8.28026 12.7789 8.05921 12.5066 8.05921H9.05263C8.78026 8.05921 8.55921 8.28026 8.55921 8.55263V12.0066C8.55921 12.2789 8.78026 12.5 9.05263 12.5H12.5066C12.7789 12.5 13 12.2789 13 12.0066V8.55263ZM13 0.493421C13 0.221053 12.7789 0 12.5066 0H9.05263C8.78026 0 8.55921 0.221053 8.55921 0.493421V3.94737C8.55921 4.21974 8.78026 4.44079 9.05263 4.44079H12.5066C12.7789 4.44079 13 4.21974 13 3.94737V0.493421ZM4.94079 0.493421C4.94079 0.221053 4.71974 0 4.44737 0H0.993421C0.721053 0 0.5 0.221053 0.5 0.493421V3.94737C0.5 4.21974 0.721053 4.44079 0.993421 4.44079H4.44737C4.71974 4.44079 4.94079 4.21974 4.94079 3.94737V0.493421Z",
    fill: "#292929"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.5c071c4b32f61903121d5e9cb45d1130.svg";
export { ForwardRef as ReactComponent };